<template>
  <div class="ringHolder">
    <svg
        v-bind:width="size"
        v-bind:height="size"
      >
      <text class="centerText" v-bind:class="{small: progress>=1}" v-bind:x="size/2" v-bind:y="size/2">{{Math.floor(progress*100)}}%</text>
      <circle class="ring"
          v-bind:r="radius"
          v-bind:stroke-width="strokeWidth"
          v-bind:cx="size/2"
          v-bind:cy="size/2"
          fill="transparent"
          v-bind:stroke="baseColor"
          />
      <circle class="ring"
          v-bind:r="radius"
          v-bind:stroke-width="strokeWidth"
          v-bind:stroke-dasharray="`${circumference} ${circumference}`"
          v-bind:stroke-dashoffset="circumference - circumference*progress"
          v-bind:cx="size/2"
          v-bind:cy="size/2"
          fill="transparent"
          v-bind:stroke="color"
          />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ProgressRing",
  props: {
    size: Number,
    progress: Number,
    strokeWidth: Number,
    color: String,
    baseColor: String
  },
  computed: {
    radius() {return this.size/2 - this.strokeWidth},
    circumference() {return this.radius*2*Math.PI},
  }
}
</script>

<style scoped lang="scss">
.ringHolder {
  display: inline-block;

  .ring {
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }
}

.centerText {
  fill: #8195a7;
  font-weight: bold;
  font-size: 7pt;
  letter-spacing: -0.5pt;
  dominant-baseline: central;
  text-anchor: middle;

  &.small {
    font-size: 5.5pt;
  }
}
</style>